$(document).ready(function () {
  
  $('#shopify-section-template--16000394035390__16476920169a4b96e2').after($('#section-text-columns-with-icons'));

   $('#closeMczr').click(function(){
    history.back();
   });

  $('#refreshMczr').click(function(){
    $( '#mczrProductIframe' ).attr( 'src', function ( i, val ) { return val; });
  });

  $('.mczr_button').css('opacity',0.9);
  
  $('.product__sample').click(function() {
  	var url = $(this).data('url');
    window.location.href=url;
 });
  
  $('.remove-labels-link').click(function() {
    $('.remove.label-product')[0].click();
  });
  
})
         
function ExtendCartLabels() {

  const labelStock = parseInt($('#label_stock_qty').val());

  var totalQty = 0;
  $('.cart-qty').each(function() {
  totalQty += parseInt($(this).val());
  });
  
  $('.stock-value').text(totalQty);

  if ( labelStock < totalQty ) {
    
    $('.addLabelsButton').addClass('hide');
    $('.label-stock-low').removeClass('hide'); 
    if ( $('.remove.label-product').length > 0 ) {
      setTimeout(function(){ $('.remove.label-product')[0].click()},100);
    }

  } else if ( totalQty < 1 ) {
       $('.addLabelsButton').addClass('hide');
     if ( $('.remove.label-product').length > 0 ) {
       setTimeout(function(){ $('.remove.label-product')[0].click()},100);
      }
  } else {
    if ( $('.remove.label-product').length == 0 ) {
      $('.add-labels-link').removeClass('hide');
      $('.remove-labels-link').addClass('hide');  
    } else {
      $('.add-labels-link').addClass('hide');
      $('.remove-labels-link').removeClass('hide');  
    }

    $('.addLabelsButton').removeClass('hide');
    $('.label-stock-low ').addClass('hide');

  }
}

document.addEventListener('DOMContentLoaded', function() {
  const toggleButton = document.querySelector('[data-js-toggle]');
  const toggleContent = document.querySelector('[data-js-content]');

  if(toggleButton) {
    toggleButton.addEventListener('click', function() {
      const expanded = toggleButton.getAttribute('aria-expanded') === 'true';
  
      toggleButton.setAttribute('aria-expanded', !expanded);
      toggleContent.setAttribute('aria-hidden', expanded);
    });
  }
});

// BSS-custom-show MC
const currentPath = window.location.pathname;

const pathsToCheck = ['/product', '/collection', '/search', '/cart'];

const containsPath = pathsToCheck.some(function(path) {
    return currentPath.includes(path);
});

if (containsPath) {
    
} else {
    const intervalId = setInterval(() => {
      const block = document.querySelector('.bss-currency-wrapper')
      if (block) {
        block.style.opacity = 0
        clearInterval(intervalId);
      }
    }, 500);
    setTimeout(() => {
      clearInterval(intervalId);
    }, 3000)
}
// BSS-custom-show MC